import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import Container from 'atoms/Container';
import Button from 'layout/atoms/Button';
import Grid from 'layout/atoms/Grid';
import Input from 'layout/atoms/Input/Input';
import ProjectsList from 'layout/organisms/ProjectsList/ProjectsList';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { AppDispatch } from 'store';
import { selectLayout, setSearchQuery } from 'store/layoutSlice';
import {
    selectFilteredProjects,
    selectWorkspaceData,
} from 'store/workspaceSlice';
import { AddProject } from './AddProject';
import EmptyState from './EmptyState';
import { ProjectsArchive } from './ProjectsArchive';
import WorkspaceTasks from './WorkspaceTasks';

const PlanPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const workspaceData = useSelector(selectWorkspaceData);
    const layoutState = useSelector(selectLayout);
    const filteredProjects = useSelector(selectFilteredProjects);
    const [displayArchive, setDisplayArchive] = useState<boolean>(false);

    const searchQuery = layoutState.searchQuery.toLowerCase();
    const filteredWorkspaceTasks = workspaceData.tasks
        .filter((t) => t.state !== 'DONE')
        .filter(
            (t) => !searchQuery || t.name.toLowerCase().includes(searchQuery)
        );
    const hasNoSearchResults =
        searchQuery.trim() !== '' &&
        filteredWorkspaceTasks.length === 0 &&
        filteredProjects.length === 0;

    useEffect(() => {}, []);
    const navigate = useNavigate();

    return (
        <>
            <Container size="s">
                <Input
                    name="search"
                    value={layoutState.searchQuery}
                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        dispatch(setSearchQuery(e.target.value))
                    }
                    placeholder={t('PLAN.SEARCH')}
                    fullWidth
                    icon={<SearchIcon />}
                />
            </Container>
            {hasNoSearchResults ? (
                <Container size="s" marginTop="16">
                    <p
                        style={{
                            textAlign: 'center',
                            opacity: 0.5,
                            padding: '32px 0',
                        }}
                    >
                        {t('PLAN.NO_RESULTS', {
                            query: layoutState.searchQuery,
                        })}
                    </p>
                </Container>
            ) : (
                <>
                    <Container size="s" marginTop="16">
                        <WorkspaceTasks />
                    </Container>
                    <ProjectsList />
                </>
            )}
            <Container size="s" marginTop="16">
                <Grid columns={1} gap={12}>
                    {workspaceData.projects.length === 0 && <EmptyState />}
                    <AddProject />
                    <div>
                        {!workspaceData.access.archives && (
                            <small
                                style={{ opacity: 0.8, cursor: 'pointer' }}
                                onClick={() => navigate('/subscription')}
                            >
                                {t('PLAN.ARCHIVED_PROJECTS_LOCKED', {
                                    count: workspaceData.archivedProjectsCount,
                                })}
                            </small>
                        )}
                        {workspaceData.access.archives &&
                            workspaceData.archivedProjectsCount > 0 &&
                            !displayArchive && (
                                <Button
                                    theme="blank"
                                    onClick={() => setDisplayArchive(true)}
                                >
                                    {t('PLAN.SHOW_ARCHIVED_PROJECTS', {
                                        count: workspaceData.archivedProjectsCount,
                                    })}
                                </Button>
                            )}
                        {workspaceData.access.archives &&
                            workspaceData.archivedProjectsCount > 0 &&
                            displayArchive && (
                                <Button
                                    theme="blank"
                                    onClick={() => setDisplayArchive(false)}
                                >
                                    {t('PLAN.HIDE_ARCHIVED_PROJECTS')}
                                </Button>
                            )}
                    </div>
                </Grid>
            </Container>
            <Container size="s" marginTop="16">
                {workspaceData.archivedProjectsCount > 0 && displayArchive && (
                    <ProjectsArchive />
                )}
            </Container>
        </>
    );
};

export default PlanPage;
